import React, { useMemo, useCallback } from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';

import colors from '../../../theme/colors';

// Types
import { DisplayItem } from '../../../types';

const useStyles = makeStyles(() => ({
  inlineSpacer: {
    display: 'inline-block',
    width: 20,
  },
  coverageLabel: {
    color: colors.abbey,
    fontSize: 14,
  },
  hiddenRow: {
    color: colors.silver,
  },
}));

type ListContentvalueType = {
  contentItems: DisplayItem[];
  adjustToDesktop?: boolean;
};

const ListContent = ({
  contentItems,
  adjustToDesktop = false,
}: ListContentvalueType): JSX.Element => {
  const classes = useStyles();
  const mdColSize = useMemo(() => (adjustToDesktop ? 6 : 12), [
    adjustToDesktop,
  ]);

  const makeRow = useCallback(
    (text: React.ReactNode, value: string): React.ReactElement => {
      return (
        <Grid
          key={value}
          item
          xs={12}
          md={mdColSize}
          container
          alignItems="flex-start"
        >
          <Grid item xs={12} container justifyContent="flex-start">
            <Typography variant="caption" className={classes.coverageLabel}>
              {value}
            </Typography>
          </Grid>
          <Grid item xs={12} container>
            {typeof text !== 'string' && <> {text} </>}
            {typeof text === 'string' && (
              <Typography variant="body2">{text}</Typography>
            )}
          </Grid>
        </Grid>
      );
    },
    [classes, mdColSize],
  );

  return (
    <>
      <Grid container spacing={2} alignItems="flex-end">
        {contentItems.map(
          (row): React.ReactElement => makeRow(row.Text, row.Value),
        )}
      </Grid>
    </>
  );
};

export default ListContent;
